import { render, staticRenderFns } from "./ConfigUi.vue?vue&type=template&id=5f4706e9"
import script from "./ConfigUi.vue?vue&type=script&lang=ts"
export * from "./ConfigUi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports